import debounce from 'lodash/debounce';
import UiElement from '../../../shared/ui-element/ui-element';
import jump from '../../utils/jump';
import analytics, { events } from '../../../shared/analytics';
import IntersectionObserver from '../../utils/intersection-observer/intersection-observer';

import './go-up-button.scss';


class GoUpButton extends UiElement {
  target: HTMLElement;

  ui = {
    goUpButton: '.js-go-up-button',
  }

  events = {
    'click @ui.goUpButton': 'handleGoUpButtonClick',
  }

  goUpButtonHiddenClass = 'go-up-button_hidden';

  constructor(target) {
    super();
    this.target = target;
  }

  onInit() {
    new IntersectionObserver(this.handleScrollToTarget).observe(this.target);
  }

  handleGoUpButtonClick = () => {
    analytics.trackEvent(events.CONTENT_UP_CLICK);
    jump(this.target, { offset: -100 });
  };

  handleScrollToTarget = ({ up, down }) => {
    debounce(() => {
      if (down) {
        (this.ui.goUpButton as unknown as HTMLElement).classList.remove(this.goUpButtonHiddenClass);
      }
      if (up) {
        (this.ui.goUpButton as unknown as HTMLElement).classList.add(this.goUpButtonHiddenClass);
      }
    }, 300)();
  };
}

export default GoUpButton as UiElement;
